module.exports = __webpack_public_path__ + "static/media/bitmap@2x (02).63c381f9.jpg";